
import React from "react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTrigger,
} from "../../../../components/ui/animated-modal";
import { motion } from "motion/react";

function EUC() {
  return (
    <Modal>
      <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
        <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
          <ModalTrigger className="">
            <div class="flex items-center forImage">
              <img
                class="rounded-full mr-4"
                src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                alt=""
              />
              <div class="text-lg">
                <p class="text-gray-900 leading-none">EUC</p>{" "}
              </div>
            </div>
          </ModalTrigger>
        </div>
      </div>

      <ModalBody>
        <ModalContent>
          <div className="flex items-center justify-center">
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              moDAL cONTENT
            </span>
          </div>
        </ModalContent>
      </ModalBody>
    </Modal>
  );
}

export default EUC;

